import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import '../assets/golf-club.css'
import i18n from '../i18n';

class GolfClub extends Component {
  constructor(props) {
    super(props);
    this.changeLanguage(this.props.match.params.lang)
  }

  changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  render() {
    const { t } = this.props;
    const handleClickBack = (id) => {
        this.props.history.push(`/golf-course-detail/1/${localStorage.getItem("i18nextLng")}`)
      };
    return (
    <div id="app">
         <h6 className="text-left back-title" onClick={() => handleClickBack()}><span className="icon-back">{`<`}</span> Alpha Golf Club</h6>
         <div className="container">
            {/* <h4 className="text-left"> <i class="ti-angle-left" style={{color:"#0E4194",background: "#E8EDFC" ,borderRadius: "50%"}}></i> Alpha Golf Club</h4> */}
        
                <table style={{ border: "1px solid #dddddd"}}>
                <tr style={{background: "#EFEEF3"}}>
                    <th>{t('hole')}</th>
                    <th>{t('par')}</th>
                    <th>{t('distance')}</th>
                </tr>
                <tr>
                    <td>1</td>
                    <td>4</td>
                    <td>398</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>5</td>
                    <td>353</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>4</td>
                    <td>413</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>4</td>
                    <td>343</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>4</td>
                    <td>456</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>4</td>
                    <td>344</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>4</td>
                    <td>455</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>4</td>
                    <td>567</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>4</td>
                    <td>670</td>
                </tr>
                <tr style={{background: "#EFEEF3"}} className="text-color">
                    <td>{t('out')}</td>
                    <td>36</td>
                    <td>4567</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>4</td>
                    <td>398</td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>5</td>
                    <td>353</td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>4</td>
                    <td>413</td>
                </tr>
                <tr>
                    <td>13</td>
                    <td>4</td>
                    <td>343</td>
                </tr>
                <tr>
                    <td>14</td>
                    <td>4</td>
                    <td>456</td>
                </tr>
                <tr>
                    <td>15</td>
                    <td>4</td>
                    <td>344</td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>4</td>
                    <td>455</td>
                </tr>
                <tr>
                    <td>17</td>
                    <td>4</td>
                    <td>567</td>
                </tr>
                <tr>
                    <td>18</td>
                    <td>4</td>
                    <td>670</td>
                </tr>
                <tr style={{background: "#EFEEF3"}} className="text-color">
                    <td>{t('in')}</td>
                    <td>36</td>
                    <td>4567</td>
                </tr>
                <tr className="total weight-text text-color">
                    <td>{t('total')}</td>
                    <td>72</td>
                    <td>6578</td>
                </tr>
                </table>
        </div>
    </div>

    );
  }
}

export default withNamespaces()(GolfClub);